import { apiCall } from "./service";
import {
  URL_JOURNEY_SESSIONS,
  URL_JOURNEY_SESSION_DETAIL,
  URL_JOURNEY_ACTIVE_USERS,
} from "./URL";

const sessionsListRequest = (params) =>
  apiCall.get({ url: URL_JOURNEY_SESSIONS, params: params || {}, isAuthToken: true });

const sessionDetailRequest = (sessionId, params = {}) =>
  apiCall.get({
    url: URL_JOURNEY_SESSION_DETAIL(sessionId),
    params: {
      page: params.page ?? 1,
      per_page: params.per_page ?? 25,
    },
    isAuthToken: true,
  });

const activeUsersRequest = (params) =>
  apiCall.get({ url: URL_JOURNEY_ACTIVE_USERS, params: params || {}, isAuthToken: true });

export default {
  sessionsListRequest,
  sessionDetailRequest,
  activeUsersRequest,
};
